module.exports = __webpack_public_path__ + "img/frame1.f41f5bc4.jpg";